import { routerReducer } from 'react-router-redux';

export default routerReducer;


// WEBPACK FOOTER //
// ./src/reducers/router.js